import {redirect as redirectTo} from '@tanstack/react-router'

import {isAuthenticatedAtom} from '@/auth/hooks/useIsAuthenticated'
import {SignInRoute} from '@/routeRegistry'

/**
 * Only allow authenticated users to access the route.
 *
 * @param store - Jotai store
 * @param redirect - The route to redirect to if the user is not authenticated.
 */
export default function privateRoute(store: ReturnType<typeof useStore>, redirect: string) {
  const isAuthenticated = store.get(isAuthenticatedAtom)
  if (!isAuthenticated) {
    throw redirectTo({
      to: SignInRoute.fullPath,
      search: {
        redirect,
      },
    })
  }
}
